import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

export const api = axios.create({
  baseURL: API_BASE,
});